var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.$attrs.compis || 'text',_vm._g(_vm._b({ref:_vm.$attrs.compis,tag:"component"},'component',{ ..._vm.TYPE[_vm.$attrs.compis || 'text'], ..._vm.$attrs },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }